<template>
	<div class="text-left font-Inter">
		<p class="text-xs font-medium text-won-green">
			Talk to Our Team
		</p>

		<h2 class="mt-0.5 text-xl leading-7 font-semibold text-won-blue">
			Are you applying to the right roles?
		</h2>

		<p class="mt-2 text-sm leading-5 text-won-secondary">
			Logging applications feels like progress - but not if they're the wrong titles. The job you'd be great at might be posted under a name you'd never search. Talk to our team and make sure your effort's pointed at the right roles.
		</p>

		<div class="mt-4 flex flex-col gap-2 rounded-lg border border-won-green-light bg-won-green-hover p-4">
			<div class="flex items-center gap-1">
				<StarIcon
					v-for="n in 5"
					:key="n"
					class="size-4 text-won-yellow"
				/>
			</div>

			<p class="text-sm leading-5 text-won-dark-blue">
				"Despite applying to 30–40 jobs a day, I wasn't getting offers, just burnout. I turned to Wonsulting for a resume review, but the advisor told me something unexpected: 'Your resume's fine, you need a better strategy.' That advice changed everything… Within two months, I landed interviews, and eventually, roles at SMBC Group and now at Zenith Technology."
			</p>

			<div class="flex items-center gap-2">
				<div class="size-8 shrink-0 overflow-hidden rounded-full">
					<img
						:src="AbhijeetP"
						alt="Abhijeet P."
						class="size-full object-cover"
					/>
				</div>

				<div>
					<p class="text-xs font-medium text-won-dark-blue">
						Abhijeet P.
					</p>
					<p class="text-xs text-won-secondary">
						Landed: Business Analyst @ Zenith Technology
					</p>
				</div>
			</div>
		</div>

		<div class="mt-6 flex flex-col gap-2 px-12">
			<button
				type="button"
				class="h-9 w-full cursor-pointer rounded-md bg-won-green text-sm font-medium text-white"
				@click="() => serviceNudgesStore.nudgeCtaClickHandler(serviceNudgesStore.FEATURES.jobTrackerAi)"
			>
				Not Sure? Talk to Us
			</button>

			<button
				type="button"
				class="h-9 w-full cursor-pointer rounded-md bg-won-sand-light text-sm font-medium text-won-dark-blue"
				@click="serviceNudgesStore.closeModal"
			>
				Maybe Later
			</button>
		</div>
	</div>
</template>

<script setup>
import { StarIcon } from '@heroicons/vue/20/solid';
import { useServicesNudges } from '../../../store/services-nudges.store';

const serviceNudgesStore = useServicesNudges();
const AbhijeetP = '/img/abhijeet-p.webp';
</script>
